import classNames from 'clsx';
import React, { memo, ReactElement } from 'react';

import styles from './DropNotify.css';

interface IProps {
    text?: string;
    isError?: boolean;
    isDraggingOver: boolean;
    isWarning?: boolean;
}

/* eslint-disable complexity */
export const DropNotify = memo(function DropNotify({ text = 'Переместить', isError, isDraggingOver, isWarning }: IProps): ReactElement | null {
    if (!isDraggingOver) {
        return null;
    }

    return (
        <div className={classNames(styles.root, { 
            [styles.root_error]: isError,
            [styles.root_warning]: isWarning,
        })}>
            {text}
        </div>
    );
});
